import { render, staticRenderFns } from "./NoteContextMenu.vue?vue&type=template&id=14c19912&scoped=true&"
import script from "./NoteContextMenu.vue?vue&type=script&lang=js&"
export * from "./NoteContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c19912",
  null
  
)

export default component.exports